import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import rewardsActions from 'models/Rewards/actions'
import { EVENT_TYPE } from 'resources'
import { APP_URLS } from 'resources/urls'

import { sendAnalyticsEvent } from 'services/analytics'
import formatPoints from 'utils/format-points'
import getDecimalValue from 'utils/get-decimal-value'

import {
  RewardItemCard,
  RewardItemContainer,
  RewardItemInfoRow,
  RewardItemImage,
  RewardItemInfo,
  RewardItemNameRow,
  RewardItemName,
  RewardItemDescription,
  RewardArrow,
  DisabledRewardContainer,
} from './styles'

const RewardProductItem = ({ product, isDisabled = false }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const redemptionDescription = useCallback(() => {
    if (product.id === 'shares') {
      return `${product.minShares}+ shares`
    }

    const redemptionValues = product?.redemptionValues || [0]
    const minValue = getDecimalValue(redemptionValues[0])
    return redemptionValues.length === 1 ? formatPoints(minValue, true) : `${formatPoints(minValue)}+ points`
  }, [product.id, product.minShares, product.redemptionValues])

  const handleProductPress = () => {
    dispatch(
      rewardsActions.setRedemptionGoal.init(product?.id, product?.redemptionValues[0], (isSuccess) => {
        if (isSuccess) {
          dispatch(
            rewardsActions.fetchRedemptionGoal.init(() => {
              if (product?.id === 'shares') {
                history.push(APP_URLS.SHARES_FOR_REDEMPTION)
              } else {
                history.push(APP_URLS.WALLET)
              }
            }),
          )
          sendAnalyticsEvent(EVENT_TYPE.walletRedeemClick, { product: product?.name })
        }
      }),
    )
  }

  return (
    <DisabledRewardContainer isDisabled={isDisabled}>
      <RewardItemCard onClick={handleProductPress}>
        <RewardItemContainer>
          <RewardItemInfoRow>
            <RewardItemImage src={product?.imageUrl} alt={product?.name} />
            <RewardItemInfo>
              <RewardItemNameRow>
                <RewardItemName>{product?.name}</RewardItemName>
              </RewardItemNameRow>
              <RewardItemDescription>{redemptionDescription()}</RewardItemDescription>
            </RewardItemInfo>
          </RewardItemInfoRow>
        </RewardItemContainer>
        <RewardArrow className="killi-icon-arrow-forward-ios" />
      </RewardItemCard>
    </DisabledRewardContainer>
  )
}

RewardProductItem.propTypes = {
  product: PropTypes.shape({
    categoryId: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    redemptionValues: PropTypes.arrayOf(PropTypes.string).isRequired,
    isTop: PropTypes.bool.isRequired,
    description: PropTypes.string,
    minShares: PropTypes.number,
    sharePrice: PropTypes.string,
  }).isRequired,
  isDisabled: PropTypes.bool,
}

export default RewardProductItem
